import * as ed from "@noble/ed25519";
import { sha512, sha256 } from "@noble/hashes/sha2.js";

// Enable synchronous Ed25519 (noble v3 requires a sha512 provider for sync ops).
ed.hashes.sha512 = sha512;

// Ephemeral in-memory reviewer key — regenerated fresh on every page load.
const { secretKey, publicKey } = ed.keygen();

export const OPERATOR_KEY_ID = "Demo-Reviewer-Key";
export const OPERATOR_PUBKEY = ed.etc.bytesToHex(publicKey);
export const OPERATOR_SESSION_START = new Date().toISOString();
// SHA-256 fingerprint of the public key, formatted as colon-separated hex pairs.
export const OPERATOR_FINGERPRINT = ed.etc
  .bytesToHex(sha256(publicKey))
  .slice(0, 32)
  .match(/.{2}/g)
  .join(":")
  .toUpperCase();

// Sign the SHA-256 hash of the audit entry payload with the ephemeral key.
export function signOperator(payloadObj) {
  const operator_payload = JSON.stringify(payloadObj);
  const digest = sha256(new TextEncoder().encode(operator_payload));
  const signature = ed.sign(digest, secretKey);
  return {
    operator_key_id: OPERATOR_KEY_ID,
    operator_payload,
    operator_digest: ed.etc.bytesToHex(digest),
    operator_signature: ed.etc.bytesToHex(signature),
    operator_pubkey: OPERATOR_PUBKEY,
  };
}
